import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { Trans } from 'lingui-react';

import TextDiv from 'elements/TextDiv';

import messages from './messages';
import Wrapper from './Wrapper';
import Title from './Title';
import Instruction from './Instruction';

function NoFavoritesPanel({ filter }) {
  return (
    <Wrapper>
      <FontAwesome name="star-o" />
      <Title>
        <Trans id={messages.title} />&nbsp;
        <TextDiv modifiers={['heavyText', 'inline']}><Trans id={filter} /></TextDiv>
      </Title>
      <Instruction>
        <Trans id={messages.instruction} />
      </Instruction>
    </Wrapper>
  );
}

NoFavoritesPanel.propTypes = {
  filter: PropTypes.string.isRequired,
};

export default NoFavoritesPanel;



// WEBPACK FOOTER //
// ./components/NoFavoritesPanel/index.js